module.exports = __webpack_public_path__ + "static/img/daily_legend.bd9fc01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/automode/daily_legend.png
// module id = 697
// module chunks = 1